export const featureCallout = () => {
  // Video controls
  const videoContainer = document.querySelector('.js__callout__videoContainer');
  if (!videoContainer) return;

  const video = videoContainer.querySelector('video');
  const playPauseBtn = videoContainer.querySelector(
    '.js__callout__videoPlayPause',
  );
  const muteBtn = videoContainer.querySelector('.js__callout__videoMute');

  const videoPausedIcon = playPauseBtn.querySelector('.js__videoPaused');
  const videoPlayingIcon = playPauseBtn.querySelector('.js__videoPlaying');

  const videoMutedIcon = muteBtn.querySelector('.js__videoMuted');
  const videoUnmutedIcon = muteBtn.querySelector('.js__videoUnmuted');

  if (!video) {
    console.error('Video element not found.');
    return;
  }

  // Ensure video is loaded before adding event listeners
  const initVideoControls = () => {
    // Set initial mute state
    if (video.muted) {
      videoMutedIcon?.classList.add('hidden');
      videoUnmutedIcon?.classList.remove('hidden');
    } else {
      videoMutedIcon?.classList.remove('hidden');
      videoUnmutedIcon?.classList.add('hidden');
    }

    // Play/Pause video
    playPauseBtn?.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        videoPausedIcon?.classList.add('hidden');
        videoPlayingIcon?.classList.remove('hidden');
      } else {
        video.pause();
        videoPausedIcon?.classList.remove('hidden');
        videoPlayingIcon?.classList.add('hidden');
      }
    });

    // Mute/Unmute video
    muteBtn?.addEventListener('click', function () {
      video.muted = !video.muted;
      if (video.muted) {
        videoMutedIcon?.classList.add('hidden');
        videoUnmutedIcon?.classList.remove('hidden');
      } else {
        videoMutedIcon?.classList.remove('hidden');
        videoUnmutedIcon?.classList.add('hidden');
      }
    });
  };

  if (video.readyState >= 1) {
    initVideoControls();
  } else {
    video.addEventListener('loadedmetadata', initVideoControls);
  }
};
